/* @flow */
import {
  changeTitle,
  changeTitleAlignment
} from '@website/components/CommonActions'
import { cropableImageModalActionMaker } from '@website/components/ActionMakers'

export default dispatcher => {
  const addRow = (idx: string) => {
    dispatcher({
      type: 'ADD_ROW',
      value: idx
    })
  }

  const removeRow = (idx: string) => {
    dispatcher({
      type: 'REMOVE_ROW',
      value: idx
    })
  }

  const _changeTitle = (title: string) => {
    dispatcher(changeTitle(title))
  }

  const _changeTitleAlignment = alignment => {
    dispatcher(changeTitleAlignment(alignment))
  }

  const imageActions = (
    idx: number,
    rowCount: number,
    itemIdx: number,
    imageUrl: string
  ) => [
    ...cropableImageModalActionMaker(dispatcher)({
      keyForSizes: 'portfolio7',
      showRemove: false,
      additionalArgs: { idx, itemIdx },
      imageUrl
    })
  ]

  return {
    addRow,
    removeRow,
    imageActions,
    changeTitle: _changeTitle,
    changeTitleAlignment: _changeTitleAlignment
  }
}
